//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FabricSearch from "@/components/q-fabric-search.vue";
import PluginReadonlyContainer from "@/components/Diagrams/sidebar/plugin-readonly-container.vue";
import { PLUGIN_CUSTOM_PROPS } from "@/components/Diagrams/sidebar/const/plugin-custom-props";

export default {
    name: "QFabricSelect",
    components: {
        FabricSearch,
        PluginReadonlyContainer
    },
    props: {
        hasRightIcon: { type: Boolean, default: false }, // show icon on right side
        label: { type: String, default: "" }, // q-fabric select - label
        dataList: { type: null }, // q-fabric-select - options list ex : [ {id:"", name:""} ]
        placeholder: { type: String, default: "" }, // q-fabric-select - placeholder
        fitParentContainer: { type: Boolean, default: false }, // options container width = parent width
        isMultiselect: { type: Boolean, default: false }, // enable multiple selection
        hasAvatar: { type: Boolean, default: false }, // show avatar on the left side - option
        hasIcon: { type: Boolean, default: false }, // show icon on the left side - option
        addSearch: { type: Boolean, default: false }, // show search field in options container
        descriptionProperty: { type: String, default: "" }, // show description (sublabel) - option
        useTranslate: { type: Boolean, default: false }, // use translate library to show option name
        selectFirstOption: { type: Boolean, default: false }, // select first option on load
        selectOptions: { type: null }, // options List to be selected on load
        hideClearDataIcon: { type: Boolean, default: false }, // hide - clear selected option (s) icon
        resetSelectedData: { type: Boolean, default: false }, // reset selected option (s)
        keepOneOptionSelected: { type: Boolean, default: false }, // keep one option selected
        disable: { type: Boolean, default: false }, // disable q-fabric-select
        closeOnSelection: { type: Boolean, default: false }, // enable close container options on select option
        hideCheckbox: { type: Boolean, default: false }, // hide checkbox - option
        error: { type: Boolean, default: true },
        errorLabel: { type: String, default: "" },
        keepClosed: { type: Boolean, default: false }, // prevent the select to be opened
        propsOnSearch: { type: Array, default: () => [] } // custom list of properties used on search
    },
    data() {
        return {
            selectedValue: "",
            searchValue: "",
            initialSelectedValue: [],
            openedOptions: false,
            filteredItems: [],
            multipleSelectedElements: [],
            singleSelectionElement: "",
            isOpened: false,
            valueFirstLoaded: true,
            showBullet: false,
            showError: false,
            selectedRightIconColor: false,
            sizeCanvas: PLUGIN_CUSTOM_PROPS,
            menuMinWidth: ""
        };
    },
    computed: {
        setDisable() {
            return this.disable || (this.dataList && !this.dataList.length) || !this.dataList;
        },
        hideShowClearIcon() {
            return this.hideClearDataIcon ? !this.hideClearDataIcon : (this.selectedValue && !this.keepOneOptionSelected);
        },
        setContentStyle() {
            return `width: ${this.menuMinWidth}; z-index:9999; box-shadow: none !important; border: 1px solid #376fcb; border-top:none; border-top-left-radius:0; border-top-right-radius:0`;
        }
    },
    watch: {
        dataList: {
            handler(newValue) {
                if (newValue && newValue.length) {
                    this.filteredItems = newValue;
                    this.multipleSelectedElements = [];

                    if (typeof this.selectOptions === "boolean" || (this.selectOptions && this.selectOptions.length)) {
                        this.setNewSelectedOptions();
                    } else if (this.selectFirstOption && this.filteredItems && this.filteredItems.length) {
                        this.selectedValue = this.useTranslate ? this.$t(this.filteredItems[0].name) : this.filteredItems[0].name;
                        this.multipleSelectedElements = [this.filteredItems[0]];
                    }
                }
            },
            immediate: true
        },
        error: {
            handler(newValue) {
                this.showError = newValue;
            }
        },

        selectOptions: {
            handler() {
                if (!this.valueFirstLoaded || this.keepClosed) {
                    this.setNewSelectedOptions();
                }
            }
        },
        resetSelectedData: {
            handler(newValue) {
                if (newValue) {
                    if (this.selectFirstOption) {
                        this.setFirstOption();
                    } else {
                        this.selectedValue = "";
                        this.multipleSelectedElements = [];
                    }
                } else if (!this.selectedValue && this.selectFirstOption) {
                    this.setFirstOption();
                }
            },
            immediate: true
        }
    },
    methods: {
        setWidth() {
            if (this.$refs.selectedContainer && this.$refs.selectedContainer.offsetWidth) {
                const parentWidth = this.$refs.selectedContainer.offsetWidth;
                this.menuMinWidth = `${parentWidth}px`;
            }
        },
        setFirstOption() {
            this.selectedValue = this.useTranslate ? this.$t(this.filteredItems[0].name) : this.filteredItems[0].name;
            this.multipleSelectedElements = [this.filteredItems[0]];
        },
        setNewSelectedOptions() {
            if (Array.isArray(this.selectOptions)) {
                this.multipleSelectedElements = [];
                this.selectOptions.forEach(i => {
                    const elem = this.filteredItems.find(item => item.id === i);
                    if (elem && !this.multipleSelectedElements.includes(elem)) {
                        this.multipleSelectedElements.push(elem);
                    }
                });
            } else {
                this.multipleSelectedElements = this.filteredItems.filter(item => item.id === this.selectOptions);
            }
            if (this.multipleSelectedElements[0] && this.multipleSelectedElements[0].rightIcon) {
                this.showBullet = true;
                this.selectedRightIconColor = this.multipleSelectedElements[0].color;
            } else {
                this.showBullet = false;
            }
            if (this.multipleSelectedElements[0]) {
                if (this.useTranslate) {
                    this.selectedValue = this.$t(this.multipleSelectedElements[0].name);
                } else {
                    this.selectedValue = this.multipleSelectedElements[0].name;
                }
            } else {
                this.selectedValue = "";
            }
            this.valueFirstLoaded = false;
        },
        searchItems() {
            const lowerCaseValue = this.searchValue.toLowerCase();
            this.filteredItems = this.dataList.filter(item => {
                const elementName = (this.useTranslate ? this.$t(item.name) : item.name).toLowerCase(); let
                    exist;
                exist = elementName.includes(lowerCaseValue);
                if (!exist && this.propsOnSearch && this.propsOnSearch.length) {
                    for (let i = 0; i < this.propsOnSearch.length; i++) {
                        const elem = this.propsOnSearch[i];
                        if (exist) {
                            break;
                        } else if (item[elem]) {
                            exist = item[elem].toLowerCase().includes(lowerCaseValue);
                        }
                    }
                }

                return exist;
            });
        },
        selectItem(item) {
            if (this.keepOneOptionSelected && !this.multipleSelectedElements.length) {
                this.multipleSelectedElements = [item];
            }
            if (item.rightIcon) {
                this.showBullet = true;
                this.selectedRightIconColor = item.color;
            } else {
                this.showBullet = false;
            }

            if (this.multipleSelectedElements.length) {
                if (!this.isMultiselect) {
                    this.multipleSelectedElements = (this.multipleSelectedElements.length > 1 && this.multipleSelectedElements.includes(item))
                        ? [item] : this.multipleSelectedElements;
                }
                this.selectedValue = this.useTranslate ? this.$t(this.multipleSelectedElements[0].name) : this.multipleSelectedElements[0].name;
            } else {
                this.selectedValue = "";
            }
            if (this.closeOnSelection) {
                this.$refs["popover-custom-select"].hide();
            }
        },
        toggleIcon(opened) {
            if (opened) {
                if (this.keepClosed) {
                    this.$refs["popover-custom-select"].hide();
                }
                this.initialSelectedValue = [...this.multipleSelectedElements];
            } else if (JSON.stringify(this.initialSelectedValue) !== JSON.stringify(this.multipleSelectedElements)) {
                this.$emit("selectedValues", this.getPayloadData());
            }

            if (this.searchValue && !opened) {
                this.searchValue = "";
                this.filteredItems = this.dataList;
            }
            if (!this.keepClosed) {
                this.isOpened = opened;
            }
            this.openedOptions = !this.openedOptions;
        },
        clearValue() {
            this.selectedValue = "";
            this.multipleSelectedElements = [];
            this.$emit("clearOption");
            this.$emit("selectedValues", this.getPayloadData());
        },
        getPayloadData() {
            let selectedValue;
            if (this.isMultiselect) {
                selectedValue = this.multipleSelectedElements.length ? this.multipleSelectedElements.map(element => element.id) : [];
            } else {
                selectedValue = this.multipleSelectedElements.length ? this.multipleSelectedElements[0].id : "";
            }
            return selectedValue;
        }
    }
};
